var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLineAnimation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 156,
    height: 25,
    viewBox: "0 0 156 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.03125 12.6288C18.4764 4.65708 35.9144 1.6677 53.3525 4.15885C66.3064 6.15177 76.7693 12.1306 88.2286 17.1129C109.154 25.0845 133.069 22.0951 152.998 12.6288",
    stroke: "#19223F",
    strokeWidth: 5.6082,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLineAnimation);
export default __webpack_public_path__ + "static/media/line-animation.e33553f755c61db10c3b3171e8908478.svg";
export { ForwardRef as ReactComponent };